import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import EditNoneMember from './EditNoneMember'

class ParselEditNoneMember extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={EditNoneMember} {...props}/>
   )
 }
}



export default ParselEditNoneMember;
